import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = {
  key: 0,
  class: "card seq-card mb-5 mb-xl-10"
}
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "card-header border-0 pt-5" }
const _hoisted_5 = { class: "card-title align-items-center" }
const _hoisted_6 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_7 = { class: "card-label fw-bold fs-3" }
const _hoisted_8 = { class: "card-body py-3 mb-5" }
const _hoisted_9 = { class: "seq-reminder-link mb-3" }
const _hoisted_10 = { class: "seq-reminder-link__main" }
const _hoisted_11 = { class: "seq-badge seq-badge--success me-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8 me-2" }, "Your link is", -1)
const _hoisted_13 = { class: "seq-reminder-link__actions" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-share-alt" }, null, -1)
const _hoisted_15 = { class: "seq-reminder-link mb-3" }
const _hoisted_16 = { class: "seq-reminder-link__main" }
const _hoisted_17 = { class: "seq-badge seq-badge--success me-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8 me-2" }, "Your link is", -1)
const _hoisted_19 = { class: "seq-reminder-link__actions" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-share-alt" }, null, -1)
const _hoisted_21 = { class: "seq-reminder-link mb-3" }
const _hoisted_22 = { class: "seq-reminder-link__main" }
const _hoisted_23 = { class: "seq-badge seq-badge--success me-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8 me-2" }, "Your link is", -1)
const _hoisted_25 = { class: "seq-reminder-link__actions" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fas fa-share-alt" }, null, -1)
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "ms-2 text-muted fs-8" }, " to retro qualify and enjoy your Marketing benefits starting TODAY. ", -1)
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = {
  key: 1,
  class: "mb-2 text-gray-800"
}
const _hoisted_31 = { class: "mb-2 text-gray-800" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Your Prime Pair is active from ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_34 = {
  key: 2,
  class: "seq-reminder-rank mt-5"
}
const _hoisted_35 = { class: "mb-2 text-gray-800" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Your account ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" currently has ")
const _hoisted_38 = { class: "seq-trend-up" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" points and ranked ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_41 = { class: "mb-2 text-gray-800" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" You need ")
const _hoisted_43 = { class: "seq-trend-up" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" more points away to become ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "mb-0 text-muted fs-7" }, " Upgrade rank by buying more products and encouraging your group to do the same to develop more customers. Happy Networking!!! ", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("a", {
  href: "#/dashboard/mycoverage",
  class: "fw-semibold"
}, " You may now RENEW your existing coverage through My Coverage menu ", -1)
const _hoisted_48 = { class: "mb-2" }
const _hoisted_49 = {
  key: 0,
  class: "mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      (_ctx.pt != 'ovi')
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_ECP_EDP_DashboardNavigator)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card mb-5"]
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Notification2.svg" })
            ]),
            _createVNode("span", _hoisted_7, " Welcome " + _toDisplayString(_ctx.user.fname + " " + _ctx.user.lname) + "! ", 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.r2meLinkLabel), 1),
              _hoisted_12,
              _createVNode("a", {
                href: _ctx.r2meLink,
                target: "_blank",
                class: "fw-semibold seq-reminder-link__url"
              }, _toDisplayString(_ctx.r2meLink), 9, ["href"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("button", {
                type: "button",
                class: "seq-share-btn seq-share-btn--copy",
                title: _ctx.copiedKey === 'r2me' ? 'Copied!' : 'Copy link',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyLink(_ctx.r2meLink, 'r2me')))
              }, [
                _createVNode("i", {
                  class: ["fas", _ctx.copiedKey === 'r2me' ? 'fa-check' : 'fa-copy']
                }, null, 2)
              ], 8, ["title"]),
              _createVNode("button", {
                type: "button",
                class: ["seq-share-btn seq-share-btn--share", { 'is-active': _ctx.shareOpenKey === 'r2me' }],
                title: _ctx.shareOpenKey === 'r2me' ? 'Close share' : 'Share link',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShare('r2me')))
              }, [
                _hoisted_14
              ], 10, ["title"]),
              (_ctx.shareOpenKey === 'r2me')
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.shareNetworks, (network) => {
                    return (_openBlock(), _createBlock(_component_ShareNetwork, {
                      key: 'r2me-' + network.network,
                      network: network.network,
                      url: _ctx.r2meLink,
                      title: _ctx.shareTitle(_ctx.r2meLinkLabel),
                      description: _ctx.shareDescription(_ctx.r2meLinkLabel),
                      class: "seq-share-btn",
                      style: { backgroundColor: network.color },
                      "aria-label": network.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode("i", {
                          class: network.icon
                        }, null, 2)
                      ]),
                      _: 2
                    }, 1032, ["network", "url", "title", "description", "style", "aria-label"]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.ecp_welcome_data.isShowR2MELink && _ctx.r2meLink != '']
          ]),
          _withDirectives(_createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.oviShopLinkLabel), 1),
              _hoisted_18,
              _createVNode("a", {
                href: _ctx.oviShopLink,
                target: "_blank",
                class: "fw-semibold seq-reminder-link__url"
              }, _toDisplayString(_ctx.oviShopLink), 9, ["href"])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("button", {
                type: "button",
                class: "seq-share-btn seq-share-btn--copy",
                title: _ctx.copiedKey === 'ovi' ? 'Copied!' : 'Copy link',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyLink(_ctx.oviShopLink, 'ovi')))
              }, [
                _createVNode("i", {
                  class: ["fas", _ctx.copiedKey === 'ovi' ? 'fa-check' : 'fa-copy']
                }, null, 2)
              ], 8, ["title"]),
              _createVNode("button", {
                type: "button",
                class: ["seq-share-btn seq-share-btn--share", { 'is-active': _ctx.shareOpenKey === 'ovi' }],
                title: _ctx.shareOpenKey === 'ovi' ? 'Close share' : 'Share link',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleShare('ovi')))
              }, [
                _hoisted_20
              ], 10, ["title"]),
              (_ctx.shareOpenKey === 'ovi')
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.shareNetworks, (network) => {
                    return (_openBlock(), _createBlock(_component_ShareNetwork, {
                      key: 'ovi-' + network.network,
                      network: network.network,
                      url: _ctx.oviShopLink,
                      title: _ctx.shareTitle(_ctx.oviShopLinkLabel),
                      description: _ctx.shareDescription(_ctx.oviShopLinkLabel),
                      class: "seq-share-btn",
                      style: { backgroundColor: network.color },
                      "aria-label": network.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode("i", {
                          class: network.icon
                        }, null, 2)
                      ]),
                      _: 2
                    }, 1032, ["network", "url", "title", "description", "style", "aria-label"]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.ecp_welcome_data.isShowR2MELink && _ctx.oviShopLink != '']
          ]),
          _withDirectives(_createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.ecverseLinkLabel), 1),
              _hoisted_24,
              _createVNode("a", {
                href: _ctx.ecverseLink,
                target: "_blank",
                class: "fw-semibold seq-reminder-link__url"
              }, _toDisplayString(_ctx.ecverseLink), 9, ["href"])
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("button", {
                type: "button",
                class: "seq-share-btn seq-share-btn--copy",
                title: _ctx.copiedKey === 'ecverse' ? 'Copied!' : 'Copy link',
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyLink(_ctx.ecverseLink, 'ecverse')))
              }, [
                _createVNode("i", {
                  class: ["fas", _ctx.copiedKey === 'ecverse' ? 'fa-check' : 'fa-copy']
                }, null, 2)
              ], 8, ["title"]),
              _createVNode("button", {
                type: "button",
                class: ["seq-share-btn seq-share-btn--share", { 'is-active': _ctx.shareOpenKey === 'ecverse' }],
                title: _ctx.shareOpenKey === 'ecverse' ? 'Close share' : 'Share link',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleShare('ecverse')))
              }, [
                _hoisted_26
              ], 10, ["title"]),
              (_ctx.shareOpenKey === 'ecverse')
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.shareNetworks, (network) => {
                    return (_openBlock(), _createBlock(_component_ShareNetwork, {
                      key: 'ecverse-' + network.network,
                      network: network.network,
                      url: _ctx.ecverseLink,
                      title: _ctx.shareTitle(_ctx.ecverseLinkLabel),
                      description: _ctx.shareDescription(_ctx.ecverseLinkLabel),
                      class: "seq-share-btn",
                      style: { backgroundColor: network.color },
                      "aria-label": network.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode("i", {
                          class: network.icon
                        }, null, 2)
                      ]),
                      _: 2
                    }, 1032, ["network", "url", "title", "description", "style", "aria-label"]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.ecp_welcome_data.isShowR2MELink && _ctx.ecverseLink != '']
          ]),
          _withDirectives(_createVNode(_component_SeqNoticeCard, {
            variant: "warning",
            title: "Retro Qualification",
            class: "mb-4 mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode("p", _hoisted_27, " You did not qualify Last Month (" + _toDisplayString(_ctx.ecp_welcome_data.lastMonth) + ")! To enjoy your Marketing Plan benefits for this month. ", 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-seq-blue",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showRetroPMAPage()))
              }, " Purchase Double PMA "),
              _hoisted_28
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.ecp_welcome_data.isShowRetroPMAButton]
          ]),
          (_ctx.isShowQualifiedMessage)
            ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
                key: 0,
                variant: "success",
                title: 'PMA Reminder for ' + _ctx.user.usid,
                class: "mb-4 mt-4"
              }, {
                default: _withCtx(() => [
                  _createVNode("p", _hoisted_29, _toDisplayString(_ctx.unilevelMaintenancePromptMessage), 1)
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2)
            ? (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("p", _hoisted_31, [
            _hoisted_32,
            _createVNode("b", null, _toDisplayString(_ctx.ecp_welcome_data.ext_f), 1),
            _hoisted_33,
            _createVNode("b", null, _toDisplayString(_ctx.ecp_welcome_data.ext_t), 1)
          ], 512), [
            [_vShow, 
            _ctx.ecp_welcome_data.ext_f !== '' &&
            _ctx.ecp_welcome_data.ext_t !== '' &&
            _ctx.ecp_welcome_data.ext_f !== undefined &&
            _ctx.ecp_welcome_data.ext_t !== undefined
          ]
          ]),
          (
            _ctx.ecp_welcome_data.currentRank != 'GA' &&
            _ctx.ecp_welcome_data.currentRank != 'GM' &&
            _ctx.ecp_welcome_data.currentRank != 'RB' &&
            _ctx.ecp_welcome_data.currentRank != 'DM'
          )
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _createVNode("p", _hoisted_35, [
                  _hoisted_36,
                  _createVNode("b", null, "(" + _toDisplayString(_ctx.ecp_welcome_data.usid) + ")", 1),
                  _hoisted_37,
                  _createVNode("b", _hoisted_38, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.ecp_welcome_data.currentPV).toFixed(4))), 1),
                  _hoisted_39,
                  _createVNode("b", null, _toDisplayString(_ctx.ecp_welcome_data.currentRank), 1),
                  _hoisted_40
                ]),
                _createVNode("p", _hoisted_41, [
                  _hoisted_42,
                  _createVNode("b", _hoisted_43, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.ecp_welcome_data.awaypv).toFixed(4))), 1),
                  _hoisted_44,
                  _createVNode("b", null, _toDisplayString(_ctx.ecp_welcome_data.nextRank), 1),
                  _hoisted_45
                ]),
                _hoisted_46
              ]))
            : _createCommentVNode("", true),
          (_ctx.renewBannerFlag && _ctx.pt === 'ovi')
            ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
                key: 3,
                variant: "warning",
                title: "Important Notice",
                class: "mb-4 mt-6"
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _withDirectives(_createVNode(_component_SeqNoticeCard, {
        variant: "warning",
        title: 'PMA Reminder for ' + _ctx.user.usid,
        buttons: _ctx.pmaReminderButtons,
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode("p", _hoisted_48, _toDisplayString(_ctx.unilevelMaintenancePromptMessage1) + " " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage2), 1),
          (_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2)
            ? (_openBlock(), _createBlock("p", _hoisted_49, _toDisplayString(_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "buttons"]), [
        [_vShow, _ctx.isShowPMAWarning]
      ])
    ], 512), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
}